const appConfig = {
  region: 'ap-northeast-1',
  IdentityPoolId: 'ap-northeast-1:7518fc31-a431-4c96-9994-e08935668e9d',
  UserPoolId: 'ap-northeast-1_xn9ihTu0b',
  ClientId: '21k0f9nk8nn7le0jko3gbo5m78',
};

export default appConfig;


const bucketname = 'kuki-app-bucket';
const tablename = 'kuki-table';
const commenttable = 'kuki-comment';
const noimage = 'no-image';
const noimageurl='http://'+bucketname+'.s3-'+appConfig.region+'.amazonaws.com/contents/images/ap-northeast-1:b6d0709b-b7b2-4d8c-a3b3-551c0e4174b2/kuki.jpg';
const nothumbnailurl='http://'+bucketname+'.s3-'+appConfig.region+'.amazonaws.com/contents/thumbnail/ap-northeast-1:b6d0709b-b7b2-4d8c-a3b3-551c0e4174b2/kuki.jpg';
const cachepath = 'contents/cache.json';

function toLocaleString( date ) {
    return [
        date.getFullYear(),
        date.getMonth() + 1,
        date.getDate()      
        ].join( '/' ) + ' '
        + date.toLocaleTimeString();
}

function makeCommentKey(identityId, uploadTime) {
   return ( identityId + '_' + uploadTime.toString() );
}


//https://qiita.com/saekis/items/c2b41cd8940923863791
function escape_html (string) {
  if(typeof string !== 'string') {
    return string;
  }
  return string.replace(/[&'`"<>]/g, function(match) {
    return {
      '&': '&amp;',
      "'": '&#x27;',
      '`': '&#x60;',
      '"': '&quot;',
      '<': '&lt;',
      '>': '&gt;',
    }[match]
  });
}

function nl2br(str) {
    str = str.replace(/\r\n/g, "<br />");
    str = str.replace(/(\n|\r)/g, "<br />");
    return str;
}

//https://reactjs.org/docs/dom-elements.html
function createMarkup(html_str) {
  return {__html: nl2br(html_str)};
}

export {bucketname,tablename,commenttable,toLocaleString,makeCommentKey,noimage,noimageurl,nothumbnailurl,escape_html,createMarkup,cachepath};




// WEBPACK FOOTER //
// ./src/appConfig.js